// extracted by mini-css-extract-plugin
module.exports = {"resultScoreSectionStyle":"_7NB5EXBquq1N5wugLApOz"};